"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIcon = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const tokens_1 = require("../../styles/tokens");
exports.StyledIcon = styled_components_1.default.svg `
    height: ${({ size }) => tokens_1.SIZES[size]};
    width: ${({ size }) => tokens_1.SIZES[size]};
    vertical-align: top; // Fix spacing & outline https://stackoverflow.com/a/24626986/3224333

    transition: 0.3s transform ease-in;

    ${({ rotation }) => {
    let degrees;
    switch (rotation) {
        case "up":
            degrees = -180;
            break;
        case "left":
            degrees = 90;
            break;
        case "right":
            degrees = -90;
            break;
        case "down":
        default:
            degrees = 0;
            break;
    }
    if (degrees || degrees === 0) {
        return `transform: rotate(${degrees}deg);`;
    }
}}
`;
//# sourceMappingURL=Icon.styles.js.map